import { generateUniqueId } from '../../helpers/common';

export const SET_STATION_TIME_OFFSET = generateUniqueId();

export const FETCH_USER_DOWNLOAD_REQUESTS_REQUEST = generateUniqueId();
export const FETCH_USER_DOWNLOAD_REQUESTS_FAILURE = generateUniqueId();
export const FETCH_USER_DOWNLOAD_REQUESTS_SUCCESS = generateUniqueId();
export const SET_SELECTED_STATION_NAMES = generateUniqueId();
export const FETCH_YEAR_INDICES_REQUEST = generateUniqueId();
export const FETCH_YEAR_INDICES_SUCCESS = generateUniqueId();
export const FETCH_YEAR_INDICES_FAILURE = generateUniqueId();

export const FETCH_BY_IDS_REQUEST = generateUniqueId();
export const FETCH_BY_IDS_SUCCESS = generateUniqueId();
export const FETCH_BY_IDS_FAILURE = generateUniqueId();

export const CREATE_DOWNLOAD_REQUEST_REQUEST = generateUniqueId();
export const CREATE_DOWNLOAD_REQUEST_FAILURE = generateUniqueId();
export const CREATE_DOWNLOAD_REQUEST_SUCCESS = generateUniqueId();

export const DELETE_DOWNLOAD_REQUEST_REQUEST = generateUniqueId();
export const DELETE_DOWNLOAD_REQUEST_SUCCESS = generateUniqueId();
export const DELETE_DOWNLOAD_REQUEST_FAILURE = generateUniqueId();

export const SET_START_DATE = generateUniqueId();
export const SET_END_DATE = generateUniqueId();

export const LOAD_YEARS_REQUEST = generateUniqueId();
export const LOAD_YEARS_FAILURE = generateUniqueId();
export const LOAD_YEARS_SUCCESS = generateUniqueId();

export const LOAD_SELECTED_STATION_TIME_REQUEST = generateUniqueId();
export const LOAD_SELECTED_STATION_TIME_FAILURE = generateUniqueId();
export const LOAD_SELECTED_STATION_TIME_SUCCESS = generateUniqueId();

export const DOWNLOAD_FILE_REQUEST = generateUniqueId();
export const DOWNLOAD_FILE_SUCCESS = generateUniqueId();
export const DOWNLOAD_FILE_FAILURE = generateUniqueId();

export const GET_FIND_STATIONS_FIELDS_REQUEST = generateUniqueId();
export const GET_FIND_STATIONS_FIELDS_FAILURE = generateUniqueId();
export const GET_FIND_STATIONS_FIELDS_SUCCESS = generateUniqueId();

export const SET_FETCH_INTERVAL = generateUniqueId();
export const CLEAR_FETCH_INTERVAL = generateUniqueId();

export const OPEN_SNACK_BAR = generateUniqueId();
export const CLOSE_SNACK_BAR = generateUniqueId();

export const TOGGLE_STATIONS_FIELDS_DIALOG = generateUniqueId();

export const CLOSE_ALERT_DIALOG = generateUniqueId();

export const DOWNLOAD_AVALIABLE_TIME = generateUniqueId();
export const DOWNLOAD_AVALIABLE_TIME_SUCCESS = generateUniqueId();
export const DOWNLOAD_AVALIABLE_TIME_FAIL = generateUniqueId();

export const GENERATE_DOWNLOAD_REPORT = generateUniqueId();
export const GENERATE_DOWNLOAD_REPORT_SUCCESS = generateUniqueId();
export const GENERATE_DOWNLOAD_REPORT_FAILURE = generateUniqueId();

export const SELECT_DOWNLOAD_REPORT_STATION = generateUniqueId();

export const SELECT_DOWNLOAD_REPORT_YEAR = generateUniqueId();
export const SELECT_DOWNLOAD_REPORT_MONTH = generateUniqueId();

export const CHECK_DOWNLOAD_REPORT_OBJECT = generateUniqueId();
export const LIST_DOWNLOAD_REPORT_OBJECT = generateUniqueId();
export const GENERATE_DOWNLOAD_REPORT_LINK = generateUniqueId();

export const SELECT_DOWNLOAD_DATA_STATION = generateUniqueId();
export const RESET_DOWNLOAD_DATA_STATION = generateUniqueId();

export const SELECT_DOWNLOAD_DATA_YEAR = generateUniqueId();
export const SELECT_DOWNLOAD_DATA_MONTH = generateUniqueId();

export const CHECK_DOWNLOAD_DATA_OBJECT = generateUniqueId();
export const LIST_DOWNLOAD_DATA_OBJECT = generateUniqueId();
export const GENERATE_DOWNLOAD_DATA_LINK = generateUniqueId();

export const CLEAR_SELECTED_FILES = generateUniqueId();

export const LIST_DOWNLOAD_CONFIG_OBJECT = generateUniqueId();
export const GENERATE_DOWNLOAD_CONFIG_LINK = generateUniqueId();

export const CURRENT_DOWNLOAD_DATA_STATION = generateUniqueId();
export const CURRENT_DOWNLOAD_REPORT_STATION = generateUniqueId();
export const CURRENT_DOWNLOAD_CONFIG_STATION = generateUniqueId();

export const RESET_DOWNLOAD_DATA = generateUniqueId();
export const RESET_REPORT_DATA = generateUniqueId();
export const RESET_CONFIG_DATA = generateUniqueId();